import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

import LabeledContent from '../LabeledContent';

import { DataPairProps } from './types';

const DATA_PAIR_LABEL_CLASS_NAME = 'data-pair__label';
const DATA_PAIR_CONTENT_CONTAINER_CLASS_NAME = 'data-pair__content-container';

const StyledLabeledContent = styled(LabeledContent)`
  && {
    flex-direction: row;

    .${DATA_PAIR_LABEL_CLASS_NAME} {
      width: 8.3rem;
      display: inline-block;
      margin: 0 2rem 0 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .${DATA_PAIR_CONTENT_CONTAINER_CLASS_NAME} {
      font-weight: 700;
    }
  }
`;

const DataPair = ({
  label,
  children,
  className,
  contentContainerClassName,
  labelClassName,
}: DataPairProps) => (
  <StyledLabeledContent
    label={label}
    className={className}
    labelClassName={classnames(DATA_PAIR_LABEL_CLASS_NAME, labelClassName)}
    contentContainerClassName={
      classnames(DATA_PAIR_CONTENT_CONTAINER_CLASS_NAME, contentContainerClassName)
    }
  >
    {children}
  </StyledLabeledContent>
);

export default DataPair;
